import { BrandKey } from '@prismamedia/one-brandkey';
import Axios from 'axios';
import { NlfNewsletters } from 'types';

const mapNLFactoryBrand = (brandKey: BrandKey) => {
  switch (brandKey) {
    case BrandKey.FRGTS:
      return 'GEN';

    case BrandKey.FROMM:
      return 'OMM';

    default:
      return brandKey;
  }
};

export const getNlFactoryByBrand = async (brandKey: BrandKey | undefined) => {
  if (!brandKey) {
    return [];
  }

  const nlFactoryNewsletter = await Axios.get<NlfNewsletters[]>(
    `https://nl-factory-v2.prismadata.fr/nl-by-brand/${mapNLFactoryBrand(
      brandKey,
    )}`,
  );

  return nlFactoryNewsletter.data;
};
